import ErrorSectionLarge from "./ErrorSectionLarge";
import ErrorSectionSmall from "./ErrorSectionSmall";
import { ErrorSectionProps } from "./types";

export default function ErrorSection({
  type,
  button,
  ...props
}: ErrorSectionProps) {
  if (type === "LARGE") {
    return <ErrorSectionLarge {...props} button={button} />;
  }
  return <ErrorSectionSmall {...props} button={button} />;
}
